// Search for : /* VariableType */ to find all places where VariableType iteration is used

export enum VariableType
{
    // Any
    Any = "Any",
    // BOOLEAN
    Boolean = "Boolean",
    // INTEGER
    TinyInt = "TinyInt",
    SmallInt = "SmallInt",
    MediumInt = "MediumInt",
    Integer = "Integer",
    BigInt = "BigInt",
    // FLOAT
    Float = "Float",
    Double = "Double",
    Decimal = "Decimal",
    Real = "Real",
    Money = "Money",
    // STRING
    String = "String",
    Date = "Date",
    Time = "Time",
    // Date
    DateTime = "DateTime",
    // STRING
    TimeZone = "TimeZone",
    Duration = "Duration",
    Email = "Email",
    Phone = "Phone",
    Version = "Version",
    IPV4 = "IPV4",
    IPV6 = "IPV6",
    IPV4Range = "IPV4Range",
    IPV6Range = "IPV6Range",
    Color = "Color",
    Font = "Font",
    FilePath = "FilePath",
    URL = "URL",
    Enum = "Enum",
    Entity = "Entity",
    // Complex
    Array = "Array",
    Object = "Object",
    Type = "Type",
    Variable = "Variable",
}